const countries = {
  ai: { display: 'anguilla', domain: 'kyliecosmetics.com', locale: 'en-ai' },
  am: { display: 'armenia', domain: 'kyliecosmetics.com', locale: 'en-am' },
  au: { display: 'australia', domain: 'kyliecosmetics.com', locale: 'en-au' },
  at: { display: 'austria', domain: 'kyliejennercosmetics.eu', locale: 'en-at' },
  bs: { display: 'bahamas', domain: 'kyliecosmetics.com', locale: 'en-bs' },
  bh: { display: 'bahrain', domain: 'kyliecosmetics.com', locale: 'en-bh' },
  be: { display: 'belgium', domain: 'kyliejennercosmetics.eu', locale: 'en-be' },
  ba: { display: 'bosnia & herzegovina', domain: 'kyliejennercosmetics.eu', locale: 'en-ba' },
  vg: { display: 'the british virgin islands', domain: 'kyliecosmetics.com', locale: 'en-vg' },
  bn: { display: 'brunei', domain: 'kyliecosmetics.com', locale: 'en-bn' },
  bg: { display: 'bulgaria', domain: 'kyliejennercosmetics.eu', locale: 'en-bg' },
  ca: { display: 'canada', domain: 'kyliecosmetics.com', locale: 'en-ca' },
  cn: { display: 'china', domain: 'kyliecosmetics.com', locale: 'en-cn' },
  co: { display: 'colombia', domain: 'kyliecosmetics.com', locale: 'en-co' },
  cr: { display: 'costa rica', domain: 'kyliecosmetics.com', locale: 'en-cr' },
  cy: { display: 'cyprus', domain: 'kyliejennercosmetics.eu', locale: 'en-cy' },
  cz: { display: 'czechia', domain: 'kyliejennercosmetics.eu', locale: 'en-cz' },
  dk: { display: 'denmark', domain: 'kyliejennercosmetics.eu', locale: 'en-dk' },
  do: { display: 'the dominican republic', domain: 'kyliecosmetics.com', locale: 'en-do' },
  ee: { display: 'estonia', domain: 'kyliejennercosmetics.eu', locale: 'en-ee' },
  et: { display: 'ethiopia', domain: 'kyliecosmetics.com', locale: 'en-et' },
  fi: { display: 'finland', domain: 'kyliejennercosmetics.eu', locale: 'en-fi' },
  fr: { display: 'france', domain: 'kyliejennercosmetics.eu', locale: 'fr-fr' },
  de: { display: 'germany', domain: 'kyliejennercosmetics.eu', locale: '' },
  gr: { display: 'greece', domain: 'kyliejennercosmetics.eu', locale: 'en-gr' },
  gl: { display: 'greenland', domain: 'kyliecosmetics.com', locale: 'en-gl' },
  hu: { display: 'hungary', domain: 'kyliejennercosmetics.eu', locale: 'en-hu' },
  is: { display: 'iceland', domain: 'kyliejennercosmetics.eu', locale: 'en-is' },
  in: { display: 'india', domain: 'kyliecosmetics.com', locale: 'en-in' },
  ie: { display: 'ireland', domain: 'kyliejennercosmetics.eu', locale: 'en-ie' },
  im: { display: 'isle of man', domain: 'kyliecosmetics.com', locale: 'en-im' },
  il: { display: 'israel', domain: 'kyliecosmetics.com', locale: 'en-il' },
  it: { display: 'italy', domain: 'kyliejennercosmetics.eu', locale: 'it-it' },
  jo: { display: 'jordan', domain: 'kyliecosmetics.com', locale: 'en-jo' },
  lv: { display: 'latvia', domain: 'kyliejennercosmetics.eu', locale: 'en-lv' },
  lb: { display: 'lebanon', domain: 'kyliecosmetics.com', locale: 'en-lb' },
  li: { display: 'liechtenstein', domain: 'kyliejennercosmetics.eu', locale: 'en-li' },
  lt: { display: 'lithuania', domain: 'kyliejennercosmetics.eu', locale: 'en-lt' },
  lu: { display: 'luxembourg', domain: 'kyliejennercosmetics.eu', locale: 'en-lu' },
  mt: { display: 'malta', domain: 'kyliejennercosmetics.eu', locale: 'en-mt' },
  mx: { display: 'mexico', domain: 'kyliecosmetics.com', locale: 'en-mx' },
  mc: { display: 'monaco', domain: 'kyliejennercosmetics.eu', locale: 'en-mc' },
  nl: { display: 'the netherlands', domain: 'kyliejennercosmetics.eu', locale: 'en-nl' },
  nz: { display: 'new zealand', domain: 'kyliecosmetics.com', locale: 'en-nz' },
  no: { display: 'norway', domain: 'kyliejennercosmetics.eu', locale: 'en-no' },
  pa: { display: 'panama', domain: 'kyliecosmetics.com', locale: 'en-pa' },
  py: { display: 'paraguay', domain: 'kyliecosmetics.com', locale: 'en-py' },
  pl: { display: 'poland', domain: 'kyliejennercosmetics.eu', locale: 'en-pl' },
  pt: { display: 'portugal', domain: 'kyliejennercosmetics.eu', locale: 'en-pt' },
  ro: { display: 'romania', domain: 'kyliejennercosmetics.eu', locale: 'en-ro' },
  sa: { display: 'saudi arabia', domain: 'kyliecosmetics.com', locale: 'en-sa' },
  sg: { display: 'singapore', domain: 'kyliecosmetics.com', locale: 'en-sg' },
  sk: { display: 'slovakia', domain: 'kyliejennercosmetics.eu', locale: 'en-sk' },
  si: { display: 'slovenia', domain: 'kyliejennercosmetics.eu', locale: 'en-si' },
  es: { display: 'spain', domain: 'kyliejennercosmetics.eu', locale: 'en-ss' },
  bl: { display: 'st. barthélemy', domain: 'kyliecosmetics.com', locale: 'en-bl' },
  mf: { display: 'st. martin', domain: 'kyliecosmetics.com', locale: 'en-mf' },
  vc: { display: 'st. vincent & grenadines', domain: 'kyliecosmetics.com', locale: 'en-vc' },
  se: { display: 'sweden', domain: 'kyliejennercosmetics.eu', locale: 'en-se' },
  ch: { display: 'switzerland', domain: 'kyliejennercosmetics.eu', locale: 'en-ch' },
  tt: { display: 'trinidad & tobago', domain: 'kyliecosmetics.com', locale: 'en-tt' },
  tc: { display: 'turks & caicos islands', domain: 'kyliecosmetics.com', locale: 'en-tc' },
  ae: { display: 'the united arab emirates', domain: 'kyliecosmetics.com', locale: 'en-ae' },
  uk: { display: 'the united kingdom', domain: 'kyliejennercosmetics.co.uk', locale: '' },
  gb: { display: 'great britain', domain: 'kyliejennercosmetics.co.uk', locale: '' },
  us: { display: 'the united states', domain: 'kyliecosmetics.com', locale: '' },
};

/**
 * Hide the modal dialog
 */
function ip_modal_hide() {
  sessionStorage.ip_modal_visibility = 'true';

  document.querySelector('.ip_modal_frame').classList.add('ip-modal-hidden');
  document.querySelector('.ip_modal_background').classList.add('ip-background-hidden');
}

/**
 * Show the modal dialog for a specific country
 *
 * @param {string} country The ISO 3166-1 2 letter country code for which to show the dialog for
 */
function ip_modal_show(country) {
  let country_name = '';

  if (country.display) {
    country_name = country.display;
  }

  const title = document.querySelector('.ip_modal_title').innerHTML
  const title_html = title + `${country_name}`;
  const primary_button_text = document.querySelector('.ip_modal_button_primary').innerHTML
  const primary_button_html = primary_button_text + `${country_name}`;

  document.querySelector('.ip_modal_title').innerHTML = title_html;
  document.querySelector('.ip_modal_button_primary').innerHTML = primary_button_html;

  const modal_box = document.querySelector('.ip_modal');

  document.querySelector('.ip_modal_frame').classList.add('ip-modal-visible');
  document.querySelector('.ip_modal_background').classList.add('ip-background-visible');

}

/**
 * Returns a string "true" if the ipmodal should be shown
 *
 * @returns {string}
 */
function get_ip_modal_cookie() {
  if (sessionStorage.ip_modal_visibility === 'true') { return 'true'; } return '';
}

const ipapi_call = new XMLHttpRequest();

let destination_url = '';
let ip_json = '';
let country = '';
let current_locale = window.location.pathname.substring(1, 6);
let destination_path = window.location.pathname;

// see if country code is valid, if not set to ""
if (!(current_locale && current_locale.match(/^[A-Za-z]{2,4}([_-][A-Za-z]{4})?([_-]([A-Za-z]{2}|[0-9]{3}))?$/g))) {
  current_locale = '';
} else { // the url path has a valid country code, fix it
  destination_path = window.location.pathname.substring(6);
}

ipapi_call.onload = function () {
  if (this.status === 200) {
    ip_json = JSON.parse(this.responseText);

    if (typeof (ip_json.countryCode !== 'undefined')) {
      const countryCode = ip_json.countryCode.toLowerCase();

      if (ip_json.countryCode.toLowerCase() in countries) {
        country = countries[ip_json.countryCode.toLowerCase()];

        destination_url = `https://${country.domain}${country.locale !== '' ? '/' : ''}${country.locale}${destination_path}`;

        document.querySelector('.ip_modal_background').addEventListener('click', ip_modal_hide);
        document.querySelector('.ip_modal_button_primary').addEventListener('click', () => { window.location.href = destination_url; });
        document.querySelector('.ip_modal_button_secondary').addEventListener('click', ip_modal_hide);

        if (countryCode.toLowerCase() !== window.Shopify.country.toLowerCase()) {
          // if we have a cookie that turned off the modal already, don't show the modal
          const ip_modal_visibility = get_ip_modal_cookie(`ip_modal_visibility_${current_locale}`);
          if (ip_modal_visibility === '') {
            ip_modal_show(country);
          }
        } else {
          console.log('ip-api: no modal');
        }
      } else { // country code not found in table
        console.error(`ip-api: Country code not supported. ${countryCode}`);
      }
    } else { // no country code defined in JSON
      console.error('ip-api: no IP address found.');
    }
  } else { // JSON returned bad status
    console.error(`ip-api: no IP address found. ${this.status}`);
  }
};
/*
 Using DOMConentLoaded instead of Load event as styles and scripts take time to load and it will then display recommendation model
 and ip modal at the same time.
 */
document.addEventListener("DOMContentLoaded", () => {
  ipapi_call.open('GET', 'https://pro.ip-api.com/json?key=hMiilpfECMHjB77', true);
  ipapi_call.send();
})
